import { validatePresence, validateFormat } from 'ember-changeset-validations/validators';
import { DISCARDED_RESPONSE_STRINGS } from 'garaje/utils/enums';

export default function buildFlowFieldValidations(field) {
  const validations = [];

  if (field.required && !(field.allowVisitorRespondents ?? true)) {
    validations.push(
      validatePresence({
        presence: true,
        message: 'This is a required field',
      }),
    );
  }

  if (field.isEmail) {
    validations.push(
      validateFormat({
        type: 'email',
        allowBlank: true,
        message: 'Please enter a valid email address',
      }),
    );
  }

  if (field.isSingleSelection) {
    // Add validation to check if the value is a valid field option
    validations.push(function validateDropdownOption(key, newValue) {
      const options = field.options;

      if (!newValue) return true;
      if (!options || options.length === 0) return true;
      if (newValue === DISCARDED_RESPONSE_STRINGS.PLACEHOLDER) return true;

      const validOptionValues = options.map((option) => option.value);
      const isValidOption = validOptionValues.includes(newValue);

      return isValidOption || 'This option is no longer available. Please choose another.';
    });
  }

  return { value: validations };
}
